// @ts-nocheck

import * as R from 'ramda';
import { LOADING_STATUS } from '../support/constants';
import { reducerWrapper } from '../support/utils';

import {
  THIRD_PARTY_PROVIDER_GET,
  THIRD_PARTY_PROVIDER_PATCH,
  THIRD_PARTY_PROVIDER_PUT,
  THIRD_PARTY_PROVIDER_SET_SELECTED,
} from '../actions/ThirdPartyProviderConfigActions';

var INIT_STATE = {
  loading: false,
  loadingStatus: LOADING_STATUS.INIT,
  error: null,
  data: null,
  espSelected: null,
};

function Handler(state, action) {
  switch (action.type) {
    case THIRD_PARTY_PROVIDER_SET_SELECTED:
      return Object.assign({}, state, {
        espSelected: action.espSelected,
      });
    case THIRD_PARTY_PROVIDER_GET.response:
      return R.merge(state, {
        loading: false,
        loadingStatus: LOADING_STATUS.LOADED,
        error: null,
        data: action.data,
      });
    /**
     * Responses for PUT and PATCH returns complete object and hence
     * the same code can be used for both
     */
    case THIRD_PARTY_PROVIDER_PUT.response:
    case THIRD_PARTY_PROVIDER_PATCH.response:
      return R.merge(state, {
        loading: false,
        loadingStatus: LOADING_STATUS.LOADED,
        error: null,
        data: R.merge(state.data, action.data),
      });

    default:
      return state;
  }
}

const ThirdPartyGlobalSettings = reducerWrapper(INIT_STATE, Handler, {
  request: [THIRD_PARTY_PROVIDER_GET, THIRD_PARTY_PROVIDER_PATCH, THIRD_PARTY_PROVIDER_PUT],
  error: [THIRD_PARTY_PROVIDER_GET, THIRD_PARTY_PROVIDER_PATCH, THIRD_PARTY_PROVIDER_PUT],
  resetOn: ['APP_CHANGE'],
});

export default ThirdPartyGlobalSettings;
